export default {
	index: 'Текущий сезон',
	history: 'История',
	account: 'Аккаунт',
};
